// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OPUac","placeholdersHeader":"styles_placeholdersHeader__y8kVM","editorStyle":"styles_editorStyle__1N0CC","placeholdersBox":"styles_placeholdersBox__mCwJr"};